import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { max } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import NewStatePopup from '../../../shared/Popups/NewStatePopup';
import WithPopup from '../../../shared/WithPopup';

export default function States() {
  const firestore = useFirestore();
  const config = useSelector((state) => state.app.prestobotsConfig);
  const [newState, setNewState] = useState({ open: false });

  const handleSubmit = (text, color) => {
    const maxStatus = max(config.states.map((e) => e.key));
    const newState = {
      label: text,
      color,
      key: maxStatus + 1,
    };
    firestore
      .collection(collections.configurations)
      .doc(config.id)
      .update({
        states: firestore.FieldValue.arrayUnion(newState),
      })
      .then(() => {
        setNewState({ open: false });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  };

  return (
    <Box mt={2} py={2}>
      <Box>
        <Typography style={{ fontSize: 18 }}>Estados</Typography>
        <Box my={2}>
          <Button variant="contained" onClick={() => setNewState({ open: true })}>
            Agregar
          </Button>
        </Box>
      </Box>
      {newState && newState.open && (
        <WithPopup handleClose={() => setNewState({ open: false })}>
          <NewStatePopup handleSubmit={handleSubmit} />
        </WithPopup>
      )}
      <Box display="flex" flexWrap="wrap">
        {config &&
          config.states &&
          config.states.map((state) => (
            <Box
              key={state.key}
              display="flex"
              alignItems="center"
              border="1px solid #eee"
              borderRadius={8}
              m={1}
              py={1}
              px={2}
            >
              <Typography style={{ minWidth: '200px' }}>{state.label}</Typography>
              <Box
                mx={1}
                sx={{
                  width: 15,
                  height: 15,
                  background: state.color || '#ffcc01',
                  borderRadius: 2,
                }}
              />
            </Box>
          ))}
      </Box>
    </Box>
  );
}
